import React, { useState } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, FilterOption, All, Empty, SearchAppState } from '../search-model';
import { completeUpdate, updateFilter, clearFilter } from '../search-slice';
import { ViewType } from '../../standalone-app/topic-page/models';

export interface Props {
    name: string,
    options: FilterOption[],
    label: string;
    clearText: string;
    setView: any;
    view: ViewType;
}

export function CheckBoxFilter(props: Props) {

    const { name, options, label, clearText, setView, view } = props;

    const [checked, setChecked] = useState([All]);
    const dispatch = useDispatch();
    const items = useSelector<SearchAppState, any[]>(a => a.searchState.lists);

    const handleChange = (evt) => {
        let copy = [...checked];
        if (evt?.currentTarget?.checked) {
            copy.push(evt?.currentTarget?.value);
            copy = evt?.currentTarget?.value === All ? [All] : copy?.filter(option => option !== All && option !== Empty);
        } else {
            copy = evt?.currentTarget?.value === All ? [Empty] : copy.filter(option => option !== evt?.currentTarget?.value);
        }
        setChecked(copy);
        const newFilter: Filter = {
            filterKey: name,
            filterOptions: copy?.map(option => {
                return {
                    filterKey: name,
                    filterValue: option,
                    filterDisplayValue: option,
                }
            }),
            partialMatch: false,
        };
        dispatch(updateFilter(newFilter));
        dispatch(completeUpdate());
    };

    const clearFilterAction = () => {
        dispatch(clearFilter());
        setChecked([All]);
    };

    const getCount = (value) => {
        return value === All ? '' : `(${items?.filter(item => item[name] === value)?.length})`;
    };

    return (
        <>
            <div className='topic-filter-top'>
                <p className='topic-filter-top-header'><svg className='info-icon' aria-hidden='true' focusable='false'>
                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#filter-icon' />
                </svg>{label}</p><button className='topic-filter-clear' type='button' onClick={clearFilterAction} >{clearText}</button>
            </div>
            <div className='topic-filter-content'>
                <div className='topic-filter-checkbox-container'>
                {
                    options?.map(option =>
                        <div className='topic-filter-checkbox-option' key={option?.filterValue}>
                            <FormControlLabel
                                key={option?.filterValue}
                                label={`${option?.filterDisplayValue} ${getCount(option?.filterValue)}`}
                                control={
                                    <Checkbox
                                        value={option?.filterValue}
                                        checked={checked?.includes(option?.filterValue)}
                                        onChange={(evt) => handleChange(evt)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                }
                            /></div>)
                    }
                </div>
                <div className='topic-filter-view-container'>
                    <button className={`topic-filter-view-button ${view === ViewType.card ? 'topic-filter-view-button-selected' : ''} `} type='button' onClick={() => setView(ViewType.card)} ><svg className='info-icon' aria-hidden='true' focusable='false'>
                        <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#grid-icon' />
                    </svg><span className='visually-hidden'>Card</span></button>
                    <button className={`topic-filter-view-button ${view === ViewType.list ? 'topic-filter-view-button-selected' : ''} `} type='button' onClick={() => setView(ViewType.list)} ><svg className='info-icon' aria-hidden='true' focusable='false'>
                        <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#list-icon' />
                    </svg><span className='visually-hidden'>List</span></button>
                </div>
            </div>
        </>
    );
}
